import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-variant", "data-theme", "disabled"]
const _hoisted_2 = { class: "Icon" }

import Icon from "@/components/ds/icon/Icon.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    iconId: {
        type: String,
        required: true,
    },
    variant: {
        type: String,
        default: "default",
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    theme: {
        type: String,
        default: "default",
    },
    type: {
        type: String,
        default: "s",
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    "data-variant": __props.variant,
    "data-theme": __props.theme,
    disabled: __props.disabled
  }, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(Icon, {
        "icon-id": __props.iconId,
        type: __props.type
      }, null, 8, ["icon-id", "type"])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})